<template>
  <div class="contact-us">
    <h1>{{$t('upgrade_page_views_static_contact_us_index_2185')}}</h1>
    <div class="item">{{$t('upgrade_page_views_static_contact_us_index_2186')}}<div class="link">
        <a href="https://line.me/ti/p/hT2U1C1Qn6" target="_blank">3uplay</a>
      </div>
    </div>
    <div class="item">{{$t('upgrade_page_views_static_contact_us_index_2187')}}<div class="link">{{$t('upgrade_page_views_static_contact_us_index_2188')}}</div>
    </div>
    <div class="item">{{$t('upgrade_page_views_static_contact_us_index_2189')}}<div class="link">
        <a href="mailto:nicee00001@gmail.com">nicee00001@gmail.com</a>
      </div>
    </div>
    <div class="item">{{$t('upgrade_page_views_static_contact_us_index_2190')}}<div class="link">
        <a href="tel:075225937">(07)5225937</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ContactUs',
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.contact-us {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
}
h1 {
  margin-bottom: 50px;
}
.item {
  display: flex;
  margin-bottom: 30px;
  font-size: 18px;
  font-weight: bold;
  color: #666;
}
.link {
  color: #6b39ff;
  a {
    color: #6b39ff;
    cursor: pointer;
  }
}
</style>
